import { Injectable } from '@angular/core';
import * as SockJS from 'sockjs-client';
import { Client, Message } from '@stomp/stompjs';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  private stompClient: any
  private connectionStatusSubject: Subject<any> = new Subject<any>();
  public BroadCastMsg = new Subject<any>();

  constructor() { }

  userId:any;
  initializeWebSocketConnection(userId:any, orderId:any): Observable<any> {


  const serverUrl = environment.serverAPI4+"/ws-endpoint";

  // const serverUrl = 'https://fast.calsoftgroup.com/ecom-gateway/ecom-svc-admin-1.0-SNAPSHOT/ws-endpoint';
  
  const ws = new SockJS(serverUrl);
  this.stompClient = new Client();

  const that = this;
  this.stompClient.configure({
    webSocketFactory: () => new SockJS(serverUrl),
    onConnect: (frame: Message) => {
      console.log('Connected to WebSocket:', frame);
     that.subscribeToMessages(userId, orderId);
      that.connectionStatusSubject.next(frame);
    }
  });

  this.stompClient.activate();
  return this.connectionStatusSubject.asObservable();
}

subscribeToMessages(userId:any, orderId:any) { 
  this.userId=userId;  
  this.stompClient.subscribe(`/user/${userId}/${orderId}/queue/private-messages`, (message: Message) => {
    if (message.body) {
      console.log('Received private message:', message.body);
      this.BroadCastMsg.next(message.body);
      // Process the message as needed
    }
  });
}

getObservableMsg = (): Subject<any> => {
  return this.BroadCastMsg;
}


}
